import { render, staticRenderFns } from "./DrugType.vue?vue&type=template&id=b53942fe&"
import script from "./DrugType.vue?vue&type=script&lang=js&"
export * from "./DrugType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports